export default "__VITE_ASSET__B6COXtn6__"